import { useState } from "react";
import { Button } from "@/components/ui/button";
import { CurrencyInput } from "@/components/ui/currency-input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogHeader, DialogBody, DialogFooter } from "@/components/ui/dialog";
import { AdminDialogHeading } from "@/components/admin/AdminDialogHeading";
import { Money } from "@phosphor-icons/react";
import { toast } from "@/lib/toast";

/** Odgovor `POST /api/companies/:id/credit/recharge`: uz dopunu se izdaje faktura. */
export interface RechargeResponse {
  invoice?: { id: string; invoiceNumber: string };
  emailed?: boolean;
}

export function toastRecharge(data: RechargeResponse, prefix: string): void {
  if (!data.invoice) return void toast.success(prefix);
  if (data.emailed === false) {
    toast.error(`${prefix}, faktura ${data.invoice.invoiceNumber} izdata, ali email firmi nije poslan. Pošaljite je ponovo iz sekcije Fakture.`);
  } else {
    toast.success(`${prefix}, faktura ${data.invoice.invoiceNumber} poslana firmi`);
  }
}

export function RechargeDialog({
  open,
  onClose,
  onSubmit,
  isPending,
  initialAmount = null,
  description = "Dodajte novi kredit na poslovni račun. Uz dopunu se firmi izdaje i šalje faktura.",
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { amount: number; note?: string }) => void;
  isPending: boolean;
  /** Iznos iz zahtjeva supervizora; admin ga može promijeniti prema stvarnoj uplati. */
  initialAmount?: number | null;
  description?: string;
}) {
  const [amount, setAmount] = useState<number | null>(initialAmount);
  const [note, setNote] = useState("");
  const valid = amount !== null && amount > 0;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogHeader onClose={onClose}>
        <AdminDialogHeading
          icon={Money}
          title="Dopuni kredit"
          description={description}
          tone="success"
        />
      </DialogHeader>
      <DialogBody>
        <div className="flex flex-col gap-3">
          <div>
            <label className="text-xs font-semibold text-muted-foreground">Iznos</label>
            <CurrencyInput
              value={amount}
              onChange={setAmount}
              placeholder="npr. 2.000,00"
              autoFocus
            />
          </div>
          <div>
            <label className="text-xs font-semibold text-muted-foreground">Napomena (opciono)</label>
            <Textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="npr. Bankovni transfer 23.04.2026"
            />
          </div>
        </div>
      </DialogBody>
      <DialogFooter>
        <Button variant="outline" onClick={onClose} disabled={isPending}>
          Otkaži
        </Button>
        <Button
          disabled={!valid || isPending}
          onClick={() => onSubmit({ amount: amount!, note: note.trim() || undefined })}
        >
          Dopuni
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
